import { render, staticRenderFns } from "./AddEditTransfers.vue?vue&type=template&id=54d4510b&scoped=true"
import script from "./AddEditTransfers.vue?vue&type=script&lang=js"
export * from "./AddEditTransfers.vue?vue&type=script&lang=js"
import style0 from "./AddEditTransfers.vue?vue&type=style&index=0&id=54d4510b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4510b",
  null
  
)

export default component.exports